import { call, put, takeEvery } from "redux-saga/effects"
import { GET_PRODUCT, GET_PRODUCT_LIST } from "./actionTypes"
import { getProductAPI, getProductListAPI } from "helpers/product_helper"

import {
  getProductSuccess,
  getProductError,
  getProductListSuccess,
  getProductListError,
} from "./actions"
import debounce from "debounce-promise"

const debouncegetProductAPI = debounce(getProductAPI, 1000)
const debouncegetProductListAPI = debounce(getProductListAPI, 1000)

function* fetchProduct(args) {
  let params = args.payload
  yield put(getProductSuccess({ status: "process", data: {} }))
  try {
    let { data } = yield call(debouncegetProductAPI, params)
    yield put(getProductSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getProductError(error?.response))
  }
}

function* fetchProductList(params) {
  yield put(getProductListSuccess({ status: "process", data: [] }))
  try {
    let { data } = yield call(debouncegetProductListAPI, params.payload)
    yield put(getProductListSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getProductListError(error?.response))
  }
}

function* fabricTradingSaga() {
  yield takeEvery(GET_PRODUCT, fetchProduct)
  yield takeEvery(GET_PRODUCT_LIST, fetchProductList)
}

export default fabricTradingSaga
